"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fonts = {
    family: {
        text: 'fakt-web, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
        code: 'Roboto Mono, monospace'
    },
    weight: {
        normal: 400,
        medium: 500,
        bold: 700
    },
    size: {
        default: '14px',
        small: '13px'
    }
};
exports.default = fonts;
//# sourceMappingURL=fonts.js.map